/**
 * Copyright Mántum All Rights Reserved.
 */
import Content from './content';
import Modal from '../../components/common/modal';
import Sidebar from '../sidebar';
import useOpen from '../../hooks/useOpen';

import type { Kanela, Action } from '@mantum/kanela';

type PropTypes = {
    action?: Action;
    children?: React.ReactElement;
    formRef?: React.RefObject<Kanela>;
    onClear?: () => void;
    onClose?: () => void;
    onSuccessSubmit?: (refresh?: string[]) => void;
    open?: boolean;
    title?: string;
};

export default function Body(props: PropTypes) {
    // prettier-ignore
    const { 
        onClose,
        onOpen,
        value: isOpen
    } = useOpen(false);

    const onClear = () => {
        onClose();
        if (props.onClear) {
            props.onClear();
        }
    };

    return (
        <>
            {isOpen && (
                <Modal
                    message='Estás seguro que deseas cancelar el registro, si lo haces perderás todo lo ingresado'
                    onNegative={onClose}
                    onPositive={onClear}
                    title='Cancelar registro'
                />
            )}
            <Sidebar
                onClose={props.onClose}
                open={props.open}
                title={props.title}
            >
                <Content
                    negative={props.action?.negative}
                    positive={props.action?.positive}
                    dataSource={props.action?.create?.dataSource}
                    refresh={props.action?.create?.refresh}
                    formRef={props.formRef}
                    onNegative={onOpen}
                    onSuccessSubmit={props.onSuccessSubmit}
                >
                    {props.children}
                </Content>
            </Sidebar>
        </>
    );
}
